import { Search as SearchIcon } from "@tamagui/lucide-icons";
import { Input } from "@medbillai/ui";
export const SearchField = ({
  label,
  value,
  onChangeText
}: {
  label: string;
  value: string;
  onChangeText: (text: string) => void;
}) => <Input shape="pill" leftIcon={SearchIcon} clearable aria-label={label} placeholder={label} value={value} onChangeText={onChangeText} autoCapitalize="none" autoCorrect={false} data-sentry-element="Input" data-sentry-component="SearchField" data-sentry-source-file="SearchField.tsx" />;